import {
  Directive,
  ElementRef,
  AfterViewInit,
  OnDestroy,
  NgZone,
  Input
} from '@angular/core';

@Directive({
  selector: 'p-dialog, p-confirmDialog, [pDialogA11y]'
})
export class DialogA11yDirective implements AfterViewInit, OnDestroy {
  @Input() closeAriaLabel: string = 'Close';

  private observer: MutationObserver | null = null;

  constructor(
    private el: ElementRef<HTMLElement>,
    private ngZone: NgZone
  ) {}

  ngAfterViewInit(): void {
    this.ngZone.runOutsideAngular(() => {
      this.applyA11y();

      if (typeof MutationObserver !== 'undefined') {
        this.observer = new MutationObserver(() => {
          this.applyA11y();
        });

        this.observer.observe(this.el.nativeElement, {
          childList: true,
          subtree: true
        });
      }
    });
  }

  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  private applyA11y(): void {
    const host = this.el.nativeElement;
    if (!host) {
      return;
    }

    const closeButtons = host.querySelectorAll<HTMLButtonElement>(
      'button.p-dialog-header-close, .p-dialog-header-close'
    );
    closeButtons.forEach((btn) => {
      const label = this.closeAriaLabel || 'Close';
      if (btn.getAttribute('aria-label') !== label) {
        btn.setAttribute('aria-label', label);
      }
    });
  }
}
